module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/lion-mobile-portuguese.ac02d176.jpg";